import addFilterCounts from './add-filter-counts';

/**
 * Given an array of research posts, builds a filter list for use with the
 * Filters component and returns it.
 * @param {Array} research - An array of Research posts.
 * @returns {Array} An array of filters.
 */
const filtersFromResearchNetwork = (research) => addFilterCounts(research
  .reduce((acc, item) => {
    const {
      meta: {
        knight_foundation_krn_member: {
          id: memberId = 0,
          name: memberName = '',
        } = {},
        knight_foundation_krn_research_publish_date: publishDate = '',
      } = {},
    } = item;

    // Add members.
    if (0 !== memberId && '' !== memberName) {
      acc[0].options.push({
        label: memberName,
        value: String(memberId),
      });
    }

    // Add publish date.
    if ('string' === typeof publishDate) {
      const year = publishDate.substring(0, 4);
      acc[1].options.push({
        label: year,
        value: year,
      });
    }

    return acc;
  }, [{
    label: 'Network Member',
    options: [],
    type: 'network-member',
  },
  {
    label: 'Published Date',
    options: [],
    type: 'year-granted',
  }]));

export default filtersFromResearchNetwork;
